import { parseUnits, readContract, writeContractAndWait } from "../viem";
import { approveToken } from ".";
import MafiaEquipmentAbi from "../../abis/MafiaEquipment.json";
import config from "../../config/config";
import { delay } from "../../utils/utils";

const address = config.equipment;
const abi = MafiaEquipmentAbi;

export const equipItems = async (
  account: string,
  cityId: number,
  itemIds: number[],
  delta: number
) => {
  if (delta > 0) {
    await approveToken(config.mafiaAddress, delta, config.equipment, account);
    await delay(config.blockTime);
  }
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "equipItems",
    args: [cityId, itemIds, parseUnits(Number(delta).toFixed(18), 18)],
    account,
  });
  return tx;
};

export const getEquipmentInfo = async (
  account: string,
  cityId: number,
  signMsg: string,
  signature: string
) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getEquipmentInfo",
    args: [account, cityId, JSON.stringify(signMsg), signature],
  });
  return {
    itemIds: data.itemIds.map((item: any) => Number(item)),
    mafiaAmount: Number(data.mafiaAmount),
    equippedAt: Number(data.equippedAt),
  };
};

export const getTotalPower = async (
  account: string,
  cityId: number,
  signMsg: string,
  signature: string
) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getTotalPower",
    args: [account, cityId, JSON.stringify(signMsg), signature],
  });
  return [Number(data[0]), Number(data[1])];
};

export {
  getCityDeveloperCityIds,
  getIsCityDeveloper,
} from "./MafiaMap";

export const getCitiesTotalPower = async (
  account: string,
  signMsg: string,
  signature: string
) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getCitiesTotalPower",
    args: [account, JSON.stringify(signMsg), signature],
  });
  return [
    data[0].map((item: any) => Number(item)),
    data[1].map((item: any) => Number(item)),
  ];
};
